<h1 mat-dialog-title>{{ 'protocolEdit.dialog.generateSign.title' | translate }}</h1>
<form>

  <div mat-dialog-content class="qualificates-theme" style="overflow-y: hidden;">

    <div fxLayout="column">
      @if (showLang) {
        <div fxFlex>
          @if (showChangeLangIcon()) {
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'common.reportType.options.language.label' | translate }}</mat-label>
              <mat-select name="lang" [(ngModel)]="reportConfig.lang">
                @for (item of langs; track item) {
                  <mat-option [value]="item.lang">
                    <mat-icon svgIcon="{{item.flag}}"></mat-icon>
                    {{item.fullLang}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      }
    </div>

  </div>

  <br /><br />

  <div mat-dialog-actions class=".qualificates-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick(false)" cdkFocusInitial>{{ getOkLabel() }}</button>
    @if (!this.nextSign) {
      <div fxFlex="5px"></div>
    }
    @if (canRefuse) {
      <button mat-raised-button color="accent" (click)="refuseSign()">{{ 'button.refuse' | translate
      }}</button>
    }
    <div fxFlex="5px"></div>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>